<template>
    <div class="page-scan-in-list">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">快遞記錄</div>
            <div class="breadcrumb-item">珠海倉記錄 差異盤點</div>
        </div>
        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <DatePicker class="no-suffix" type="date" size="small" :clearable="true" placeholder="珠海倉記錄起始日期" v-model="form.start_time" value-format="yyyy-MM-dd" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>

                <FormItem>
                    <DatePicker class="no-suffix" type="date" size="small" :clearable="true" placeholder="珠海倉記錄結束日期" v-model="form.end_time" value-format="yyyy-MM-dd" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>

                 <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        <a target="_blank" class="pg-btn style2" style="margin-left: 15px;">導出excel</a>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isLoading">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="odd_numbers">
                        <div class="avatar-box">
                            <a class="pg-btn" @click="handleViewOrder(index)">{{row.odd_numbers}}</a>
                        </div>
                </template>
                <template slot-scope="{ row, index }" slot="status">
                    <span v-if="row.status == 0">待出庫</span>
                    <span v-else-if="row.status == 1">已出庫</span>
                    <span v-else-if="row.status == 2">配送中</span>
                    <span v-else-if="row.status == 3">代取件</span>
                    <span v-else-if="row.status == 4">已簽收</span>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleEdit(index)">快遞詳細</div>
                        <div class="pg-btn style2" @click="handleMoved(index)">移出</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

        <Modal v-model="isShowModalSign_goods"
               title="查詢快件"
               width="1300"
               :footer-hide="true"
               @on-cancel="handleModalSignClose_goods">
            <div class="modal-cont">
               <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
                    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                    <div class="loading-text">Loading</div>
                </Spin>

                <div style="font-weight:bold">快遞信息</div>
                <br>
                <Table no-data-text="" :columns="table1.column" :data="table1.data"></Table>
                <Table no-data-text="" :columns="table1.column1" :data="table1.data1"></Table>
                <Table no-data-text="" :columns="table1.column2" :data="table1.data2"></Table>
                <Table no-data-text="" :columns="table1.column3" :data="table1.data3">
                    <template slot-scope="{row,index}" slot="status">
                        <span v-if="row.status == 0">珠海倉庫-待出庫</span>
                        <span v-else-if="row.status == 1">珠海倉庫-已出庫</span>
                        <span v-else-if="row.status == 2">澳門倉庫-配送中</span>
                        <span v-else-if="row.status == 3">澳門門店/智能櫃-未簽收</span>
                        <span v-else-if="row.status == 4">澳門門店/智能櫃-已簽收</span>
                    </template>
                </Table>
                <Table no-data-text="" :columns="table1.column4" :data="table1.data4"></Table>
                <Table no-data-text="" :columns="table1.column5" :data="table1.data5"></Table>
                <br><br>
                <div style="font-weight:bold">物流信息</div>
                <br>
                <div class="step-wrap" v-if="detail && detail.length">
                    <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
                        <div class="left">
                            <div class="l-date">
                                <span>{{item.date}}</span>
                                <span>{{item.week}}</span>
                            </div>
                            <div class="l-time">{{item.time}}</div>
                        </div>
                        <div class="right">
                            <div class="r-address">{{item.describe}} , 操作人：{{item.userinfos}}</div>
                        </div>
                    </div>
                </div>

                <div class="data-null" v-else>
                    <div>暫無數據</div>
                </div>
            </div>
        </Modal>

        <Modal v-model="isShowModalRefund"
               title="備注選中"
               width="400"
               :footer-hide="true"
               @on-cancel="handleModalCloseRefund">
            <div class="modal-cont">
                <Spin fix class="pg-sub-loading" v-if="isSubmitingRefund">
                    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                    <div class="loading-text">Loading</div>
                </Spin>
                <Form>
                    <FormItem>
                        <Input type="textarea" size="large" v-model="form.odd_numbers" placeholder="請輸入退款説明" :autosize="{minRows: 5,maxRows: 10}"></Input>
                    </FormItem>
                    <FormItem>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style1" style="width:100%">退款</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Store from '../../../assets/js/store.js'
    export default {
        data()
        {
            return {
                isShowModalRefund: false,
                isSubmitingRefund:false,
                pickShelves: [], //貨架號
                pickAddress: [],
                pickAdmin: [],
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '', //輸入的頁碼
                isLoading: true, //Loading開關
                detail: [],
                isShowModalSign_goods: false,
                isSubmitingLog: false,
                form: {
                    odd_numbers: '',
                    username: '',
                    phone: '',
                    shelves: '',
                    arrive: '',
                    status: '',
                    start_time: '',
                    end_time: '',
                },
                table: {
                    column: [
                        {
                            title: '日期',
                            key: 'stroeName',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '入倉件數',
                            key: 'odd_numbers',
                            slot: 'odd_numbers',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '出倉件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '門店件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '智能櫃件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '宅配件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '操作',
                            sortable: true,
                            slot: 'action',
                            align: 'center',
                            minWidth: 130
                        },
                    ],
                    data: []
                },
                table1: {
                    column: [
                        {
                            title: '快遞單號',
                            key: 'order',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '客戶電話',
                            key: 'phone',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '客戶名稱',
                            key: 'username',
                            align: 'center',
                            minWidth: 80
                        },
                    ],
                    column1: [
                        {
                            title: '重量',
                            key: 'weight',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '尺寸',
                            key: 'size_sum',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '提貨櫃點',
                            key: 'store',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column2: [
                        {
                            title: '快件明細',
                            key: 'detailed',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '異常件',
                            key: 'abnormal',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '出庫袋號',
                            key: 'sack_number',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column3: [
                        {
                            title: '最新貨態',
                            slot: 'status',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '更新時間',
                            key: 'created_time',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '貨架號',
                            key: 'shelves',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column4: [
                        {
                            title: '代收費',
                            key: 'amount',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '附加費',
                            key: 'surcharge_price',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '到附運費',
                            key: 'freight_collect',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column5: [
                        {
                            title: '超期費',
                            key: 'outTime_price',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '合計費用',
                            key: 'total_price',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    data: [],
                    data1: [],
                    data2: [],
                    data3: [],
                    data4: [],
                    data5: [],
                },
            };
        },
        created() {
            this.getPickAddress();
            this.getShelvesList();
        },
        mounted()
        {
            this.getList();
        },
        methods: {
            handleModalCloseRefund()
            {
                this.isShowModalRefund = false;
            },
            handleMoved(index)
            {
                this.isShowModalRefund = true;
                let tableData = this.table.data;
            },
            handleEdit(index){
                let tableData = this.table.data;
                this.$router.push({path: '/zhuhaiInventoryRecordDetail'});
            },
            handleInventory_Grid(index){
                let tableData = this.table.data;
                this.$router.push({path: '/zhuhaiInventoryGrid'});
            },
            getShelvesList(list) //貨架號
            {
                if(list > 0) {
                    this.$Rq.requestAuth({
                        url: this.$Api.shelvesAllList,
                        method: 'get',
                        data:{
                            store_id : list,
                        }
                    }).then((res) =>
                    {
                        if (res.code == 0)
                        {
                            this.pickShelves = res.data;
                        }
                    });
                } else {
                    this.$Rq.requestAuth({
                        url: this.$Api.shelvesAllList,
                        method: 'get',
                        data:{
                            store_id : Store.fetch().store_id,
                        }
                    }).then((res) =>
                    {
                        if (res.code == 0)
                        {
                            this.pickShelves = res.data;
                        }
                    });
                }
            },
            getPickAddress() //提貨櫃點
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress = res.data.data;
                        if (res.data.data.length <= 1) {
                            this.form.arrive = res.data.data[0].ReceivingID;
                        }
                    }
                });
            },
            handleStoreChange(index) {
                this.$refs.resetSelect.clearSingleSelect();
                this.getShelvesList(index);
            },
            handleViewOrder(index)
            {
                this.isShowModalSign_goods = true;
                this.isSubmitingLog = true;
                let tableData = this.table.data;

                this.$Rq.requestAuth({
                    url: this.$Api.all_search,
                    method: 'get',
                    data: {
                        order: tableData[index].odd_numbers
                    }
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    let tempArr = [];
                    let tempArr1 = [];
                    let tempArr2 = [];
                    let tempArr3 = [];
                    let tempArr4 = [];
                    let tempArr5 = [];
                    let resData = res.data;

                    if (res.code == 0)
                    {
                        for (let i = 0; i < resData.data.length; i++)
                        {
                            tempArr.push({
                                order: resData.data[i].order,
                                username: resData.data[i].username,
                                phone: resData.data[i].phone,
                            });

                            tempArr1.push({
                                weight: resData.data[i].weight,
                                size_sum: resData.data[i].long + 'x' + resData.data[i].width + 'x' + resData.data[i].height,
                                store: resData.data[i].store == null ? '- - -' : resData.data[i].store.ReceivingName,
                            });

                            tempArr2.push({
                                sack_number: resData.data[i].sack_number,
                                detailed: resData.data[i].detailed == null ? '- - -' : resData.data[i].detailed.name,
                                abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
                            });

                            tempArr3.push({
                                shelves: resData.data[i].shelves == null ? '- - -' : resData.data[i].shelves.code,
                                status: resData.data[i].status,
                                created_time: resData.data[i].created_time,
                            });

                            tempArr4.push({
                                amount: resData.data[i].amount,
                                surcharge_price: resData.data[i].surcharge_price,
                                freight_collect: resData.data[i].freight_collect,
                            });

                            tempArr5.push({
                                outTime_price: resData.data[i].outTime_price,
                                total_price: Number(resData.data[i].surcharge_price) + Number(resData.data[i].outTime_price) + Number(resData.data[i].freight_collect) + Number(resData.data[i].amount),
                            });
                        }
                        this.table1.data = tempArr;
                        this.table1.data1 = tempArr1;
                        this.table1.data2 = tempArr2;
                        this.table1.data3 = tempArr3;
                        this.table1.data4 = tempArr4;
                        this.table1.data5 = tempArr5;
                    }
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            
                this.isSubmitingLog = true;
                this.$Rq.requestAuth({
                    url: this.$Api.logisticsInfo + '/' + tableData[index].odd_numbers,
                    method: 'get',
                    data: {}
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    if (Number(res.code) == 0)
                    {
                        let resData = res.data;
                        let tempArr = [];
                        let userinfo;

                        for (let j = 0; j < resData.length; j++)
                        {
                            let datetime = this.getDateTime(resData[j].created_at);
                            
                            if(resData[j].userinfos == null){
                                if(resData[j].remarks.match(/[\u606d\u559c\u60a8]/g)){
                                    userinfo = '用戶線上支付';
                                }else{
                                    if(resData[i].admin_name != null){
                                        userinfo = resData[i].admin_name;
                                    }else{
                                        userinfo = '智能櫃派送員';
                                    }
                                }
                            }else{
                                userinfo = resData[j].userinfos.username;
                            }

                            tempArr.push({
                                userinfos: userinfo,
                                id: resData[j].id,
                                date: datetime.date,
                                week: datetime.week,
                                time: datetime.time,
                                describe: resData[j].remarks
                            });
                        }

                        this.detail = tempArr;
                    }
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            },
            getDateTime(datetime)
            {
                let date = new Date(datetime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                let week = date.getDay();
                let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

                return {
                    date: `${this.formateNum_log(year)}-${this.formateNum_log(month)}-${this.formateNum_log(day)}`,
                    time: `${this.formateNum_log(hour)}:${this.formateNum_log(minute)}:${this.formateNum_log(second)}`,
                    week: weekList[week]
                };
            },

            formateNum_log(num)
            {
                return num > 9 ? num : '0' + num;
            },
            handleModalSignClose_goods(){
                this.isShowModalSign_goods = false;
            },
            getPickAdmin()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAdmin,
                    method: 'post'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAdmin = res.data.data;
                    }
                });
            },

            getList()
            {
                let form = this.form;

                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.overtimelist,
                    method: 'get',
                    data: {
                        phone: form.phone,
                        storeId: form.arrive,
                        status: form.status,
                        orderNumber: form.odd_numbers,
                        start_time: form.start_time,
                        end_time: form.end_time,
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        if(resData == undefined)
                        {
                            this.totalCount = 0;
                            this.table.data = tempArr;
                        }
                        else
                        {

                            for (let i = 0; i < resData.length; i++)
                            {
                                tempArr.push({
                                    arriveCode: resData[i].arriveCode,
                                    arrive_time: resData[i].arrive_time,
                                    cainiao_match: resData[i].cainiao_match,
                                    odd_numbers: resData[i].orderNumber,
                                    orderStats: resData[i].orderStats,
                                    outDay: resData[i].outDay + '天',
                                    phone: resData[i].phone,
                                    status: resData[i].status,
                                    stroeName: resData[i].stroeName,
                                });
                            }

                            this.totalCount = res.data.count;
                            this.table.data = tempArr;
                        }
                    }
                }).catch(() =>
                {
                    this.isLoading = false;
                });
            },

            handleSearch()
            {
                this.pageIndex = 1;
                this.getList();
            },
            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'zhuhaiInventoryRecord.scss';
</style>